import type { DocumentData, DocumentSnapshot } from "firebase/firestore";
import type { TheoryLesson } from "../../model/autovioCalendarEvents";
import { autovioCalendarEventConverter } from "./autovioCalendarEventConverter";

export const theoryLessonConverter = {
  toFirestore: (_: TheoryLesson): DocumentData => {
    throw new Error("Not implemented");
  },

  fromFirestore: (doc: DocumentSnapshot): TheoryLesson => {
    const result = autovioCalendarEventConverter.fromFirestore(doc);
    if (result.type === "TheoryLesson") {
      return result;
    }
    throw Error(`Document ${doc.ref.path} is not a TheoryLesson, but: ${result.type}`);
  },
};
